import { NgModule } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { GridsterModule } from 'angular-gridster2';
import { AzavistaWidgetsModule } from '@azavista/components/widgets';
import { SharedModule } from '../shared/shared.module';
import { GlobalDashboardRoutingModule } from './global-dashboard-routing.module';
import { GlobalDashboardComponent } from './global-dashboard.component';
import { AzavistaDashboardModule } from '@azavista/components/dashboard';
import { WidgetsModule } from '../shared/widgets/widgets.module';
import { WidgetsService } from '../shared/widgets/widgets.service';

@NgModule({
    declarations: [GlobalDashboardComponent],
    imports: [
        SharedModule, MatMenuModule, MatDialogModule,
        MatSelectModule, MatButtonModule, GridsterModule,
        AzavistaWidgetsModule,
        GlobalDashboardRoutingModule,
        WidgetsModule, AzavistaDashboardModule
    ],
    providers: [WidgetsService]
})
export class GlobalDashboardModule {
}
